/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon16Solid = forwardRef('ArchiveCabinetIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1A2.5 2.5 0 0 0 2 3.5V7h11V3.5A2.5 2.5 0 0 0 10.5 1h-6Zm.75 3.25A.75.75 0 0 1 6 3.5h3A.75.75 0 0 1 9 5H6a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 8H2v4.5A2.5 2.5 0 0 0 4.5 15h6a2.5 2.5 0 0 0 2.5-2.5V8Zm-7 2.5A.75.75 0 0 0 6 12h3a.75.75 0 0 0 0-1.5H6Z" })));
});
